<pnyc-navigation-panel [items]="items()" [badgeLimit]="9" (clicked)="onItemClicked($event)">
</pnyc-navigation-panel>

<ng-template #activeCustomerTemplate>
    @let customer = activeCustomer();
    @if (customer) {
        <div class="nav-customer-btn" [title]="customer.firstName + ' ' + customer.lastName">

            <pnyc-avatar class="nav-customer-btn-avatar" [userFullName]="customer.firstName + ' ' + customer.lastName"
                [profileImageUrl]="customer.profilePictureUrl ?? ''">
            </pnyc-avatar>

            <div class="nav-customer-btn-text">{{ customer.firstName + ' ' + customer.lastName }}</div>

        </div>
    }
</ng-template>